import Vue from 'vue';
import Router from 'vue-router';
import AppHome from '../views/app/Home.vue';
import Publish from '../views/app/Publish.vue';
import Review from '../views/app/Review.vue';
import ReviewTopics from '../views/app/ReviewTopics.vue';
import BrowserOpenGuide from '../views/app/BrowserOpenGuide.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {path: '/', redirect: '/app'},
    {path: '/app', component: AppHome},
    {path: '/app/publish', component: Publish},
    {path: '/app/review', component: ReviewTopics},
    {path: '/app/review/content', component: Review},
    {path: '/app/browser-open-guide', component: BrowserOpenGuide},
    {path: '*', redirect: '/app'}
  ]
});
